/* ============================================================
 * edj-omo-quiz — custom element <edj-omo-quiz>
 * Quiz interactif 4 questions → recommandation cadeau (landing Omotenashi)
 *
 * Structure DOM attendue (rendue par Liquid SSR-safe) :
 *   <edj-omo-quiz>
 *     <div data-quiz-screen="0">…question 1…</div>
 *     <div data-quiz-screen="1">…question 2…</div>
 *     <div data-quiz-screen="2">…question 3…</div>
 *     <div data-quiz-screen="3">…question 4…</div>
 *     <div data-quiz-screen="result">…résultat…</div>
 *     <span data-quiz-progress="0|1|2|3"></span>
 *     <button data-quiz-answer="answer_key">…</button>
 *     <button data-quiz-restart>Refaire</button>
 *   </edj-omo-quiz>
 * ============================================================ */
(function () {
  if (customElements.get('edj-omo-quiz')) return;

  class EdjOmoQuiz extends HTMLElement {
    connectedCallback() {
      this._step = 0;
      this._answers = {};
      this._screens = Array.from(this.querySelectorAll('[data-quiz-screen]'));
      this._progress = Array.from(this.querySelectorAll('[data-quiz-progress]'));
      this._buttons = Array.from(this.querySelectorAll('[data-quiz-answer]'));
      this._restartBtn = this.querySelector('[data-quiz-restart]');

      this._buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => this._onAnswer(e.currentTarget));
      });
      if (this._restartBtn) {
        this._restartBtn.addEventListener('click', () => this._restart());
      }
      this._render();
    }

    _onAnswer(btn) {
      const screen = btn.closest('[data-quiz-screen]');
      if (!screen) return;
      const screenIdx = parseInt(screen.getAttribute('data-quiz-screen'), 10);
      if (isNaN(screenIdx)) return;
      this._answers[screenIdx] = btn.getAttribute('data-quiz-answer');

      const totalQuestions = this._screens.filter((s) => /^\d+$/.test(s.getAttribute('data-quiz-screen'))).length;
      if (this._step < totalQuestions - 1) {
        this._step += 1;
        setTimeout(() => this._render(), 250);
      } else {
        setTimeout(() => {
          this._step = 'result';
          this._render();
        }, 400);
      }
    }

    _restart() {
      this._step = 0;
      this._answers = {};
      this._render();
    }

    _render() {
      const target = String(this._step);
      this._screens.forEach((s) => {
        const isActive = s.getAttribute('data-quiz-screen') === target;
        s.style.display = isActive ? '' : 'none';
        if (isActive) s.setAttribute('data-quiz-active', 'true'); else s.removeAttribute('data-quiz-active');
      });
      this._progress.forEach((p) => {
        const idx = parseInt(p.getAttribute('data-quiz-progress'), 10);
        if (typeof this._step === 'number' && idx <= this._step) {
          p.setAttribute('data-state', 'active');
        } else if (this._step === 'result') {
          p.setAttribute('data-state', 'active');
        } else {
          p.removeAttribute('data-state');
        }
      });
    }
  }

  customElements.define('edj-omo-quiz', EdjOmoQuiz);
})();
